import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import Selection from './Selection';

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
  content : {
    height: '80%',
    width: '88%',
    backgroundColor: 'rgba(230, 230, 230, 1.0)',
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    position: 'absolute',
  }
};

Modal.setAppElement('#root')

const ModalManager = ({ modalIsOpen, presentedModal, poses, indexPath, dispatch }) => (

      <Modal
        isOpen={modalIsOpen}
        onRequestClose= {() => dispatch({type:'CLOSE_MODAL'})}
        style={customStyles}
        contentLabel="Example Modal"
      >

      {(presentedModal === "ADD_POSE") ? <h2>Select A Pose</h2> : <h2>Modify Pose</h2>}
      <button onClick={() => dispatch({type:'CLOSE_MODAL'})}>
        cancel
      </button>

      <button onClick={() => dispatch({type:'UPDATE_POSE', indexPath:indexPath, newPose:"_"})}>
        delete current pose
      </button>

      <Selection poseIdentifiers={poses} indexPath={indexPath}/>

    </Modal>

);

const mapStateToProps = (state) => ({
  modalIsOpen: state.modalIsOpen,
  presentedModal: state.presentedModal,
  indexPath: state.presentedModalIndexPath,
  poses: state.presentedModalPoses,
});

export default connect(mapStateToProps)(ModalManager);



// WEBPACK FOOTER //
// ./src/ModalManager.js